import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Text({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M6.66667 10.6668H8.66667V12.6668H6.66667V10.6668Z"
        fill={iconColor}
      />
      <Path
        d="M10.6667 10.6668H12.6667V12.6668H10.6667V10.6668Z"
        fill={iconColor}
      />
      <Path
        d="M14.6667 10.6668H16.6667V12.6668H14.6667V10.6668Z"
        fill={iconColor}
      />
      <Path
        d="M2.66667 4.00012C2.29848 4.00012 2 4.2986 2 4.66679V17.3335C2 17.7016 2.29848 18.0001 2.66667 18.0001H6V22.0001C6 22.2617 6.15298 22.4991 6.39119 22.6072C6.6294 22.7153 6.90881 22.6741 7.10567 22.5018L12.2505 18.0001H19.3333V16.6668H12C11.8385 16.6668 11.6825 16.7254 11.561 16.8317L7.33333 20.5309V17.3335C7.33333 16.9653 7.03486 16.6668 6.66667 16.6668H3.33333V5.33346H20.6667V18.0001H21.3333C21.7015 18.0001 22 17.7016 22 17.3335V4.66679C22 4.2986 21.7015 4.00012 21.3333 4.00012H2.66667Z"
        fill={iconColor}
      />
    </Svg>
  );
}
